import React, { useState, useRef, createContext } from "react";
import { Navigate, useNavigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { clearMessage } from "../../actions/message";
import { getCenters, deleteCenter } from "../../actions/center";
import { toast } from 'react-toastify';
import { Grid, IconButton, Button, InputLabel, Select, Switch, FormControlLabel, CircularProgress, ButtonBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../ConfirmDialog";
import Filter from "../Filter";
import "../../List.css";
import { Navigation } from "@mui/icons-material";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Chip from '@mui/material/Chip';
import { CountryDropdown } from "react-country-region-selector";
import "./Booking.css";
import { DataGridPro, GridActionsCellItem, GridToolbarExport, GridToolbarContainer, GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import { getBookings, deleteBooking } from "../../actions/booking";
import * as dayjs from "dayjs";
import { width } from "@mui/system";
import MultipleSelectChip from "./MultiSelectChip";
import ListIcon from '@mui/icons-material/List';
import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ContentCut from '@mui/icons-material/ContentCut';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPaste from '@mui/icons-material/ContentPaste';
import Cloud from '@mui/icons-material/Cloud';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import SellIcon from '@mui/icons-material/Sell';
import BookingGrid from "./BookingGrid";
import { getAgencies } from "../../actions/agency";


const BookingsManagement = (props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: currentUser } = useSelector((state) => state.auth);
  const { bookings: listBookings } = useSelector((state) => state.bookings);
  const { message } = useSelector(state => state.message);

  const [activeFilter, setActiveFilter] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [inactiveShow, setInactiveShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [showCurrentYearOnly, setShowCurrentYearOnly] = useState();

  let bookingsLoaded = false;

  const [selectedBooking, setSelectedBooking] = useState(null);

  const startYear = 2022;
  const endYear = 2050;
  const currentYear = new Date().getFullYear();
  const academicYears = Array.from({ length: endYear - startYear + 1 }, (_, index) => `${startYear + index}-${startYear + index + 1}`);

  const searchBarHelper = "Search for a booking..."

  const currentAcademicYear = () => {
    const anneeEnCours = new Date().getFullYear();
    const anneeSuivante = anneeEnCours + 1;
    return `${anneeEnCours}-${anneeSuivante}`;
  }

  const [selectedAgencyValue, setSelectedAgencyValue] = React.useState(null);
  const [selectedCenterValue, setSelectedCenterValue] = React.useState(null);
  const [statusFilter, setStatusFilter] = React.useState([]);
  const [selectedYearValue, setSelectedYearalue] = React.useState([]);
  const [filter, setFilter] = React.useState();

  const HandleFilter = (e) => {
    if (e) {
      localStorage.setItem("filter", e)
    } else {
      localStorage.removeItem("filter")
    }
    setFilter(e)
  }

  const { centers: listCenters } = useSelector((state) => state.centers);
  const { agencies: listAgencies } = useSelector((state) => state.agencies);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {

    if (!currentUser || currentUser == null) {
      navigate('/');
      return;
    }

    if (localStorage.getItem("statusFilter", statusFilter)) {
      setStatusFilter(localStorage.getItem("statusFilter", statusFilter).split(','))
    }
    // Always set `filter` to a defined string on mount (default "") — even when no text
    // search was saved. BookingGrid skips fetching while `filter === undefined`, so leaving
    // it undefined after returning from a booking detail left the grid empty until a manual
    // filter reset. Defaulting to "" lets the grid refetch with the restored filters.
    setFilter(localStorage.getItem("filter") || '')
    if (localStorage.getItem("centerFilter", selectedCenterValue)) {
      setSelectedCenterValue(localStorage.getItem("centerFilter"))
    }

    if (localStorage.getItem("yearFilter", selectedYearValue)) {
      setSelectedYearalue(localStorage.getItem("yearFilter"))
    } else {
      setSelectedYearalue(currentAcademicYear())
    }


    if (localStorage.getItem("agencyFilter", selectedAgencyValue)) {
      setSelectedAgencyValue(localStorage.getItem("agencyFilter"))
    }

    dispatch(getBookings(currentUser.id));
    dispatch(getCenters());
    dispatch(getAgencies());
  }, []);

  console.log(listCenters)
  console.log(selectedYearValue)

  useEffect(() => {
    if (statusFilter) {
      localStorage.setItem("statusFilter", statusFilter);
    }
  }, [statusFilter])

  useEffect(() => {
    if (selectedCenterValue) {
      let centerID = selectedCenterValue.id ? selectedCenterValue.id : selectedCenterValue
      localStorage.setItem("centerFilter", centerID);
    } else {
      localStorage.removeItem("centerFilter");
    }
  }, [selectedCenterValue])

  useEffect(() => {
    if (selectedAgencyValue) {
      let agencyID = selectedAgencyValue.id ? selectedAgencyValue.id : selectedAgencyValue
      localStorage.setItem("agencyFilter", agencyID);
    } else {
      localStorage.removeItem("agencyFilter");
    }
  }, [selectedAgencyValue])

  useEffect(() => {
    if (selectedYearValue) {
      localStorage.setItem("yearFilter", selectedYearValue);
    }
  }, [selectedYearValue])


  const updateActiveFilter = (e) => {
    setActiveFilter(e.target.checked);
  }

  const add_booking = () => {
    navigate("/Booking");
  }


  const StatusToText = (status) => {
    switch (status) {
      case 0:
        return 'Draft';
      case 1:
        return 'Pending approval';
      case 2:
        return 'Approved';
      case 3:
        return 'Canceled';
      case 4:
        return 'Invalid';
      case 5:
        return 'Paid';
      case 6:
        return 'Partially paid'
    }
  }

  const TextToStatus = (status) => {
    switch (status) {
      case 'Draft':
        return 0
      case 'Pending approval':
        return 1
      case 'Approved':
        return 2
      case 'Canceled':
        return 3
      case 'Invalid':
        return 4
      case 'Paid':
        return 5
      case 'Partially paid':
        return 6
    }
  }

  const getLabelTheme = (status) => {
    switch (status) {
      case "Draft":
        return "darkgrey";
      case "Pending approval":
        return "#F5A10F";
      case "Approved":
        return "#2E7D32";
      case "Canceled":
        return "grey";
      case "Invalid":
        return "crimson";
      case "Paid":
        return '#1E90FF';
      case 'Partially paid':
        return '#aacef0'
    }
  }

  const columns = [
    {
      field: 'Status', width: 175,
      align: "center",
      renderHeader: (params) => (<strong>{currentUser && currentUser.type != 2 ? 'Status' : ''}</strong>),
      renderCell: (cellValues) => {
        return (
          <>
            {currentUser && currentUser.type != 2 ? <Chip label={cellValues.value} sx={{ width: "100%", color: 'white', backgroundColor: getLabelTheme(cellValues.value.toString()) }} /> : <></>}
          </>
        );
      }
    },
    { field: 'Date', width: 175, align: 'center', renderHeader: (params) => (<strong>{'Date'}</strong>) },
    { field: 'Student', flex: 1, renderHeader: (params) => (<strong>{'Student'}</strong>) },
    { field: 'Center', flex: 1, renderHeader: (params) => (<strong>{'Centre'}</strong>) },
    { field: 'Arrival', flex: 1, renderHeader: (params) => (<strong>{'Arrival'}</strong>) },
    { field: 'Departure', flex: 1, renderHeader: (params) => (<strong>{'Departure'}</strong>) },
    { field: 'Agency', flex: 1, renderHeader: (params) => (<strong>{'Agency'}</strong>) },
    {
      field: 'actions',
      type: 'actions',
      sortable: false,
      getActions: (params) => {
        return [
          <>
            {currentUser.type == 1 &&
              <>
                <IconButton aria-label="delete" onClick={() => {
                  setSelectedBooking(params.id);
                  setConfirmOpen(true);
                }}>
                  <DeleteIcon />
                </IconButton>
                <ConfirmDialog
                  title="Delete booking ?"
                  content="Are you sure you want to delete this booking ?"
                  open={confirmOpen}
                  setOpen={setConfirmOpen}
                  onConfirm={(result) => {

                    if (result == true) {
                      dispatch(deleteBooking(selectedBooking))
                        .then(() => {
                          toast.success(
                            `Booking deleted successfuly`,
                            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                          );
                        })
                        .catch(() => {
                          toast.error(
                            `An Error occured while deleting the booking please try again later`,
                            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                          );
                        });
                    }
                  }}>
                </ConfirmDialog></>}
          </>]
      }
    }];

  const handleYearChange = (e) => {
    setSelectedYearalue(e);
  }
  const handleCenterChange = (e) => {
    setSelectedCenterValue(e);
  }

  return currentUser && listCenters ? (
    <div className="app-container">
      <Grid container >

        <Grid item>
          <h1>Bookings management</h1>
        </Grid>
      </Grid>

      <Grid container justifyContent={'start'} alignContent={'center'} alignItems={'center'} height={"100%"} spacing={1}>
        <Grid item xs={12} >

          <Filter
            setSearchQuery={HandleFilter}
            searchQuery={filter}
            helper={searchBarHelper}
            setActive={updateActiveFilter}
            addDataFunction={add_booking}
            HideActive={true}
          />
        </Grid>


        <>
          {
            currentUser.type == 1 &&

            <>
              <Grid item xs={3} mt={1} mb={1}>
                <MultipleSelectChip filter={statusFilter} setFilter={setStatusFilter} />
              </Grid>

              <Grid item xs={2}>
                <label>Centre</label>
                <Select
                  value={selectedCenterValue}
                  onChange={(e) => handleCenterChange(e.target.value)}
                  style={{ width: '100%' }} >
                  <MenuItem value={null}>{'All centres'}</MenuItem>
                  {listCenters &&
                    selectedYearValue.length > 0 &&
                    listCenters
                      .filter((c) => c.yearsWithBookings.includes(parseInt(selectedYearValue.split('-')[1])))
                      .map((center) => (
                        <MenuItem value={center.id}>{center.name}</MenuItem>
                      ))}
                </Select>
              </Grid>

              <Grid item xs={2}>
                <label>Agency</label>
                <Select
                  value={selectedAgencyValue}
                  onChange={(e) => setSelectedAgencyValue(e.target.value)}
                  style={{ width: '100%' }} >
                  <MenuItem value={null}>{'All agencies'}</MenuItem>
                  {listAgencies && listAgencies.filter((c) => c.active).map((agency) => (
                    <MenuItem value={agency.id}>{agency.name}</MenuItem>
                  ))}
                </Select>
              </Grid>
            </>
          }

          <Grid item xs={2} mt={1} mb={1}>
            <label>Academic year</label>
            <br></br>
            {selectedYearValue &&
              <Select
                value={selectedYearValue}
                onChange={(e) => handleYearChange(e.target.value)}>
                {academicYears.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            }
            <Button variant="contained" sx={{ margin: 1 }}
              onClick={() => {
                setStatusFilter([])
                setFilter('')
                setSelectedCenterValue(null)
                setSelectedAgencyValue(null)
              }}>
              Reset filters
            </Button>
          </Grid>
        </>

        {/* <Grid item xs={2}>
          <FormControlLabel
            control={
              <Switch checked={showCurrentYearOnly == 'true' ? true : false}
                onChange={(e) => {
                  localStorage.setItem('showCurrentYearOnly', e.target.checked)
                  setShowCurrentYearOnly(e.target.checked ? 'true' : 'false')
                }} />
            }
            label='Show current academic year only' />
        </Grid> */}

        <TableContainer component={Paper} >
          <Grid>
            <BookingGrid
              sx={{ height: '100%' }}

              columns={columns}

              filter={filter}
              statusFilter={statusFilter}
              centerFilter={selectedCenterValue}
              agencyFilter={selectedAgencyValue}
              yearFilter={selectedYearValue}
              TextToStatus={TextToStatus}
              StatusToText={StatusToText} />
          </Grid>
        </TableContainer>
      </Grid>


    </div>
  ) : <></>
}

export default BookingsManagement

